import { render, staticRenderFns } from "./benefitsCreat..vue?vue&type=template&id=b76c09e0&scoped=true"
import script from "./benefitsCreat..vue?vue&type=script&lang=js"
export * from "./benefitsCreat..vue?vue&type=script&lang=js"
import style0 from "./benefitsCreat..vue?vue&type=style&index=0&id=b76c09e0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b76c09e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b76c09e0')) {
      api.createRecord('b76c09e0', component.options)
    } else {
      api.reload('b76c09e0', component.options)
    }
    module.hot.accept("./benefitsCreat..vue?vue&type=template&id=b76c09e0&scoped=true", function () {
      api.rerender('b76c09e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/components/benefitsCreat..vue"
export default component.exports